<template>
  <div class="text-center my-6">
    <v-btn
      depressed
      large
      rounded
      color="primary"
      class="text-h6 font-weight-bold text-none"
      @click="purchase()"
    >
      Quiero empezar ahora
    </v-btn>
  </div>
</template>

<script>
  // import I18n from '@/Mixins/I18n'

  export default {
    mixins: [
      // I18n,
    ],

    methods: {
      purchase () {
        window.location.href = this.$store.getters['purchase/href']
      },
    },
  }
</script>
